import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, distinctUntilChanged, filter, map, merge, tap } from 'rxjs';

@Component({
  selector: 'rosie-typeahead',
  templateUrl: './typeahead.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TypeaheadComponent {
  onFocus = new Subject<string>();
  onClick = new Subject<string>();
  latestOptionsShown: string[];

  @Input() options: any[] = [];

  @Input() placeholderTranslationKey: string = '';
  @Input() customClass: string = '';
  @Input() control: FormControl | AbstractControl = new FormControl();
  @ViewChild('instance', { static: true }) instance: NgbTypeahead;

  constructor() { }

  // The popup is attached to <body> (see [container] in the template) so it
  // overlays the modal instead of being clipped by the modal body's scroll
  // container; the placement array still flips it above the field when the
  // viewport has no room below. Body attachment detaches the popup from the
  // input's width, so a popper modifier pins it back to the field.
  popperOptions = (options: any) => {
    options.modifiers = [
      ...(options.modifiers ?? []),
      {
        name: 'sameWidthAsInput',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: ({ state }: any) => {
          state.styles.popper.width = `${state.rects.reference.width}px`;
        },
        effect: ({ state }: any) => {
          state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
        },
      },
    ];
    return options;
  };

  search = (term: Observable<string>) => {
    const debouncedText = term.pipe(distinctUntilChanged());
    const clicksWithClosedPopup = this.onClick.pipe(filter(() => !this.instance?.isPopupOpen()), map(() => { this.scrollToSelectedOption() }));
    const inputFocus = this.onFocus.pipe(tap(() => { this.scrollToSelectedOption() }));

    return merge(debouncedText, clicksWithClosedPopup, inputFocus).pipe(
      map((term: string) => {
        if (term === this.control.value) {
          term = '';
        }
        return term?.length > 0 ? this.options.filter((option) => option?.toLowerCase()?.indexOf(term?.toLowerCase()) === 0) : this.options
      }),
      tap((availableOptions: string[]) => {
        this.latestOptionsShown = availableOptions;
      })
    );
  }

  selectFirstOption() {
    if (!this.control.value) {
      // this.control.patchValue(this.latestOptionsShown[0] || this.options[0]);
      // if (this.instance?.isPopupOpen()) {
      //   this.instance.dismissPopup();
      // }
    }
  }

  private scrollToSelectedOption() {
    setTimeout(() => {
      const inputElement = document.querySelector('.form-control.rosie-typeahead-input');
      if (inputElement) {
        const selectedValue = this.control.value;
        const dropdownElement = document.querySelector('.dropdown-menu.show');
        if (dropdownElement && selectedValue) {
          const optionElement = Array.from(dropdownElement.querySelectorAll('button')).find(
            option => option.textContent.trim() === selectedValue.trim()
          );
          if (optionElement) {
            // Scroll only the dropdown list itself. scrollIntoView walks every
            // scrollable ancestor, so inside a scrollable modal body it also
            // yanked the whole modal content when the popup opened.
            dropdownElement.scrollTop =
              optionElement.offsetTop - (dropdownElement.clientHeight - optionElement.offsetHeight) / 2;
          }
        }
      }
    }, 10);
  }
}
